import { UPDATE_JOB } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_JOB.LOAD:
      return {
        ...state,
        loading: true
      };
    case UPDATE_JOB.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case UPDATE_JOB.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
